import { Component, OnInit, ViewChild, ViewContainerRef, NgModule, Compiler } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { AppComponent } from '../../app.component';
import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { SelectResourceMainComponent } from './select-resource-main.component';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { SelectResourceService } from '../../service/select-resource.service';
import { DisplayService } from '../../service/display.service';
import { CustomViewService } from '../../service/custom-view.service';
import { TokenManager } from '../../service/web-api.service';
import { AuthService } from '../../service/auth.service';
import { environment } from '../../../environments/environment';

declare let gtag: any; // グローバル変数gtagを解決

@Component({
  selector: 'app-select-resource',
  templateUrl: './select-resource.component.html',
  providers: [SelectResourceService, DisplayService, CustomViewService]
})

export class SelectResourceComponent implements OnInit {

  // 画面ID
  readonly SCREEN_ID = 'O06';

  /** リソース一覧を求めているクライアント名 */
  public clientName: string;
  /** タイトルロゴ */
  public dispZ0001: string;
  /**エラーメッセージ */
  public messages: any[];

  // ページ番号定義
  public pageNo: number;
  // 操作クラス定義
  public comp: SelectResourceMainComponent;
  // テンプレートファイ名（HTML）
  public templateHtml: string;
  // テンプレートファイル（CSS）
  public templateCss: string;
  // 画面資材ルートURL
  public assetsBaseUrl: string;
  // 共通画面資材URL
  public assetsPortalBaseUrl: string;

  // リソース一覧表示
  public resourceInfoList: any[];

  // 子リソース選択画面に遷移するかどうか
  public isMulti: boolean;

  // サービス名
  public serviceName: string;

  @ViewChild('waitModal', { static: false }) waitModal: WaitModalComponent;
  @ViewChild('confirmModal', { static: false }) confirmModal: ConfirmModalComponent;

  @ViewChild('dest', { read: ViewContainerRef, static: false })
  public dest: ViewContainerRef;

  constructor(
    public router: Router,
    private displayService: DisplayService,
    private selectResourceService: SelectResourceService,
    private authService: AuthService,
    private appComponent: AppComponent,
    private customViewService: CustomViewService,
    private compiler: Compiler,
    public translateService: TranslateService) { }

  /**
   * 初期処理
   */
  async ngOnInit() {
    this.pageNo = 1;
    if (this.appComponent.dispZ0000 === undefined) {
      await this.appComponent.getDisplayInfo();
    }

    // 読み込まれるHTML名の取得
    this.serviceName = '';
    if (this.appComponent.dispZ0000 === '') {
      this.serviceName = 'portal';
    } else {
      this.serviceName = this.appComponent.dispZ0000;
    }
    this.assetsBaseUrl = environment.storageBaseUrl + '/' + this.serviceName + '/adume';
    this.assetsPortalBaseUrl = environment.storageBaseUrl + '/portal';
    this.templateHtml = this.assetsBaseUrl + '/html/select-resource/' + this.serviceName + '_select-resource';
    this.templateCss = this.assetsBaseUrl + '/css/' + this.serviceName + '_select-resource.css';

    // 画面カスタマイズ情報
    await this.displayService.execAuthDisplayInfo(this.SCREEN_ID).subscribe(data => {
      this.dispZ0001 = '';
      if (data.displayInfo != null) {
        if (data.displayInfo.Z0001 != null) {
          this.dispZ0001 = data.displayInfo.Z0001;
        }
      }

      this.clientName = data.clientName;

      this.selectResourceService.execResourceInfoList().subscribe(
        result => {
          this.resourceInfoList = result.resourceInfoList;
          this.isMulti = result.isMulti;
          // カスタムページ表示
          this.directInjection();
        },
        error => {
          this.router.navigate(['/error', 500]);
        }
      );
    });

    this.messages = [];
  }

  /**
   * コンポーネントを生成し親コンポーネントに挿入する
   *
   */
  public async directInjection() {

    gtag('config', environment.analyticsId, {
      'page_path': '/html/select-resource/' + this.serviceName + '_select-resource' + '/' + this.pageNo,
      'page_title': 'select-resource',
    });

    gtag('config', environment.analyticsIdGa4, {
      'page_title': 'select-resource',
      'page_location': this.serviceName + '/select-resource/' + this.pageNo
    });

    // 元の要素をクリアする
    this.dest.clear();

    // テンプレートを取得
    let templateHtmlText = await this.customViewService.getText(this.templateHtml + '_' + this.pageNo + '.html').toPromise();
    let templateCssText = await this.customViewService.getText(this.templateCss).toPromise();
    templateCssText = templateCssText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsPortalBaseUrl}}/g, this.assetsPortalBaseUrl);

    // Angular コンポーネントを用意する
    @Component({
      selector: 'app-select-resource-main',
      template: templateHtmlText,
      styles: [templateCssText],
    })

    class SelectResourceModuleComponent extends SelectResourceMainComponent { }
    // Angular モジュールを用意する

    @NgModule({
      imports: [CommonModule, FormsModule, PopoverModule.forRoot()],
      declarations: [SelectResourceModuleComponent],
      exports: [SelectResourceModuleComponent]
    })
    class SelectResourceModule {
    }

    // Angular モジュールとコンポーネントをコンパイルする
    const module = this.compiler.compileModuleAndAllComponentsSync(SelectResourceModule);
    // Angular モジュールから SelectResourceModuleComponent を生成するファクトリを取り出す
    const factory = module.componentFactories.find((c) => {
      return c.componentType === SelectResourceModuleComponent;
    });

    // SelectResourceModuleComponent を生成し this.dest に設定する
    const componentRef = this.dest.createComponent(factory);

    // componentのインスタンスを取得する。
    this.comp = (<SelectResourceModuleComponent>componentRef.instance);
    this.comp.init(this, this.selectResourceService, this.waitModal, this.confirmModal);
  }

}
